/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { func, bool, object } from 'prop-types';
import { Box, makeStyles } from '@material-ui/core';
import ReactHTMLParser from 'react-html-parser';

const useStyles = makeStyles((theme) => ({
    reconnectBtn: {
        margin: '0 auto',
        marginTop: '10px',
        width: '55%',
        display: 'flex',
        cursor: 'pointer',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '.5rem .75rem',
        fontSize: '1rem',
        color: '#fff',
        '&:hover': {
            color: '#fff',
        },
        backgroundColor: `${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        border: `2px solid ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        borderRadius: '.25rem',
    },
}));

const ReconnectChatButton = ({
    reconnectChat,
    isBot,
    isAigoReady,
    brand,
}) => {
    const classes = useStyles();
    /**
     * Get body message shown above reconnect button
     * @returns React element representing the html
     */
    const getDescriptionText = () => {
        let text = '';
        if (isAigoReady) {
            text = `${isBot ? 'Virtual Gifting Assistant' : 'Agent'} has left. <br/> Thanks for contacting ${brand?.description}®.`;
        }
        return ReactHTMLParser(text);
    };
    return (
        <Box
            width="90%"
            margin="0 auto"
            textAlign="center"
        >
            {getDescriptionText()}
            <button
                onClick={reconnectChat}
                className={classes.reconnectBtn}
                variant="outlined"
                size="small"
                type="button"
                id="reconnect"
                data-testid="reconnect-chat-button"
            >
                Reconnect Chat
            </button>
        </Box>

    );
};

ReconnectChatButton.propTypes = {
    isBot: bool.isRequired,
    isAigoReady: bool.isRequired,
    reconnectChat: func.isRequired,
    brand: object.isRequired,
};

export default ReconnectChatButton;
